// Generated by purs version 0.15.14
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Filterable from "../Data.Filterable/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_LoadDirection from "../Data.LoadDirection/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_TransmissionStats from "../Data.TransmissionStats/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Class_MonadApp from "../Fusion.Class.MonadApp/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_FSValue from "../Fusion.Data.FSValue/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_EnvVars_Common from "../Fusion.EnvVars.Common/index.js";
import * as Fusion_Foreign_Data_NQValue from "../Fusion.Foreign.Data.NQValue/index.js";
import * as Fusion_GenTransformers from "../Fusion.GenTransformers/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_LoadIntermediate from "../Fusion.LoadIntermediate/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Data_TransmissionStats.monoidTransmissionStats);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEither);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var show = /* #__PURE__ */ Data_Show.show(Data_Argonaut_Decode_Error.showJsonDecodeError);
var all = /* #__PURE__ */ Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var foldMap = /* #__PURE__ */ Data_Array.foldMap(Data_TransmissionStats.monoidTransmissionStats);
var eq = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var sortWith = /* #__PURE__ */ Data_Array.sortWith(MST_Data_BasicURL.ordBasicURL);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var fromJsonDecodeError2 = /* #__PURE__ */ Fusion_Data_FSError.fromJsonDecodeError2(Fusion_Foreign_Data_NQValue.nQValueMemberUploadFinalD);
var filterMap = /* #__PURE__ */ Data_Filterable.filterMap(Data_Filterable.filterableArray);
var mempty2 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Bytes.monoidBytes);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var $$null = /* #__PURE__ */ Data_Foldable["null"](Data_Foldable.foldableArray);
var fromJsonDecodeError21 = /* #__PURE__ */ Fusion_Data_FSError.fromJsonDecodeError2(Fusion_Foreign_Data_NQValue.nQValueMemberDownloadFina);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Fusion_EnvVars_Common.eqNodeEnv);
var uploadMock = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadKill3 = dictMonadApp.MonadKill3();
    var MonadError1 = (dictMonadApp.MonadBracket2()).MonadError1();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(MonadKill3)(MonadError1);
    var catchError = Control_Monad_Error_Class.catchError(MonadError1);
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var for_ = Data_Foldable.for_(Monad0.Applicative0())(Data_Foldable.foldableArray);
    var discard1 = discard(Monad0.Bind1());
    var delay = WE_Class_Time.delay(MonadAppNE4.MonadTime2());
    var throwError1 = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    return function (mockData) {
        var decode = function (fsValue) {
            if (fsValue instanceof Fusion_Data_FSValue.UploadIntermediate) {
                return pure(new Fusion_LoadIntermediate.TotalIntermediate({
                    speed: fsValue.value0.speed,
                    timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(mempty)
                }));
            };
            if (fsValue instanceof Fusion_Data_FSValue.UploadFinal) {
                return pure(new Fusion_LoadIntermediate.Final({
                    jitter: fsValue.value0.jitter,
                    speed: fsValue.value0.speed,
                    statsActive: mempty1,
                    statsPassive: mempty1
                }));
            };
            return throwError(new Data_Argonaut_Decode_Error.TypeMismatch("Expected NQValue of kind UploadIntermediate or UploadFinal"));
        };
        return form2toForm1(function (emit) {
            return Data_Function.flip(catchError)(function (err) {
                return emit(new Data_Either.Left(err));
            })(for_(mockData)(function (uploadDE) {
                return discard1(delay(Fusion_Data_Duration.fromMs(100.0)))(function () {
                    var v = decode(uploadDE);
                    if (v instanceof Data_Either.Right) {
                        return emit(new Data_Either.Right(v.value0));
                    };
                    if (v instanceof Data_Either.Left) {
                        return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl62.value)(show(v.value0)));
                    };
                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 291, column 11 - line 293, column 72): " + [ v.constructor.name ]);
                });
            }));
        });
    };
};
var stripStatsUrls = function (dictFunctor) {
    var map2 = Data_Functor.map(dictFunctor);
    return function (enableTcpStats) {
        return function (urlsWithStats) {
            if (!enableTcpStats) {
                return map2(function (v) {
                    return {
                        load: v.load,
                        stats: Data_Maybe.Nothing.value
                    };
                })(urlsWithStats);
            };
            if (enableTcpStats) {
                return urlsWithStats;
            };
            throw new Error("Failed pattern match at Fusion.LoadFinal (line 363, column 3 - line 368, column 20): " + [ enableTcpStats.constructor.name ]);
        };
    };
};
var isUsableStats = function (v) {
    if (v.sent instanceof Data_Maybe.Just && v.received instanceof Data_Maybe.Just) {
        return all(Data_Maybe.isJust)([ v.sent.value0.totalPackets, v.sent.value0.lostBytes, v.sent.value0.totalBytes, v.received.value0.outOfOrder, v.received.value0.duplicate, v.received.value0.total ]);
    };
    return false;
};
var infoGroupToModel = function (group) {
    var groupArray = Data_Array_NonEmpty.toArray(group);
    var first = Data_Array_NonEmpty.head(group);
    return {
        url: MST_Data_BasicURL.print(first.url),
        kernelName: first.kernelName,
        kernelVersion: first.kernelVersion,
        intermediateStats: map(function (s) {
            return s.stats;
        })(groupArray),
        finalStats: foldMap(function (s) {
            return s.stats;
        })(groupArray)
    };
};
var infosToModels = function (statsInfos) {
    return map(infoGroupToModel)(Data_Array.groupBy(function (a) {
        return function (b) {
            return eq(a.url)(b.url);
        };
    })(sortWith(function (v) {
        return v.url;
    })(statsInfos)));
};
var downloadMock = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadKill3 = dictMonadApp.MonadKill3();
    var MonadError1 = (dictMonadApp.MonadBracket2()).MonadError1();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(MonadKill3)(MonadError1);
    var catchError = Control_Monad_Error_Class.catchError(MonadError1);
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var for_ = Data_Foldable.for_(Monad0.Applicative0())(Data_Foldable.foldableArray);
    var discard1 = discard(Monad0.Bind1());
    var delay = WE_Class_Time.delay(MonadAppNE4.MonadTime2());
    var throwError1 = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    return function (mockData) {
        var decode = function (fsValue) {
            if (fsValue instanceof Fusion_Data_FSValue.DownloadIntermediate) {
                return pure(new Fusion_LoadIntermediate.TotalIntermediate({
                    speed: fsValue.value0.speed,
                    timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(mempty)
                }));
            };
            if (fsValue instanceof Fusion_Data_FSValue.DownloadFinal) {
                return pure(new Fusion_LoadIntermediate.Final({
                    jitter: fsValue.value0.jitter,
                    speed: fsValue.value0.speed,
                    statsActive: mempty1,
                    statsPassive: mempty1
                }));
            };
            return throwError(new Data_Argonaut_Decode_Error.TypeMismatch("Expected NQValue of kind DownloadIntermediate or DownloadFinal"));
        };
        return form2toForm1(function (emit) {
            return Data_Function.flip(catchError)(function (err) {
                return emit(new Data_Either.Left(err));
            })(for_(mockData)(function (downloadDE) {
                return discard1(delay(Fusion_Data_Duration.fromMs(100.0)))(function () {
                    var v = decode(downloadDE);
                    if (v instanceof Data_Either.Right) {
                        return emit(new Data_Either.Right(v.value0));
                    };
                    if (v instanceof Data_Either.Left) {
                        return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl61.value)(show(v.value0)));
                    };
                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 258, column 11 - line 260, column 72): " + [ v.constructor.name ]);
                });
            }));
        });
    };
};
var calcUpload = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var liftEither = Control_Monad_Error_Class.liftEither((dictMonadApp.MonadKill3()).MonadThrow1());
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (sdk) {
        return function (request) {
            return bind(sdk.calcUpload(request))(function (calcResult) {
                return bind(liftEither(lmap(fromJsonDecodeError2(Fusion_Data_FSError.Cl66.value)(calcResult))(Fusion_Foreign_Data_NQValue.decodeFSUploadFinal(calcResult))))(function (v) {
                    return pure1({
                        speed: v.speed,
                        jitter: v.jitter
                    });
                });
            });
        };
    };
};
var calcStatsFinal = function (models) {
    return foldMap(function (v) {
        return v.finalStats;
    })(filterMap(function (v) {
        var $174 = isUsableStats(v.finalStats);
        if ($174) {
            return new Data_Maybe.Just(v);
        };
        return Data_Maybe.Nothing.value;
    })(models));
};
var loadFinal = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var put = WE_Class_AVar.put(ManageAVar3);
    var MonadRef4 = MonadAppNE4.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    var groupedAverage = Fusion_GenTransformers.groupedAverage(dictMonadApp);
    var loadIntermediate = Fusion_LoadIntermediate.loadIntermediate(dictMonadApp);
    var Applicative0 = Monad0.Applicative0();
    var pure1 = Control_Applicative.pure(Applicative0);
    var discard1 = discard(Bind1);
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var MonadKill3 = dictMonadApp.MonadKill3();
    var throwError1 = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    var modify_ = WE_Class_MonadRef.modify_(MonadRef4);
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var catchError = Control_Monad_Error_Class.catchError(MonadBracket2.MonadError1());
    var MonadTime2 = MonadAppNE4.MonadTime2();
    var now = WE_Class_Time.now(MonadTime2);
    var parOneOf = Fusion_Class_MonadApp.parOneOf(MonadAppNE4.MonadRaceInParallel7())(Data_Traversable.traversableArray)(Data_FunctorWithIndex.functorWithIndexArray)(Data_Eq.eqInt);
    var voidLeft = Data_Functor.voidLeft((Bind1.Apply0()).Functor0());
    var delay = WE_Class_Time.delay(MonadTime2);
    var when = Control_Applicative.when(Applicative0);
    var read = WE_Class_MonadRef.read(MonadRef4);
    var take = WE_Class_AVar.take(ManageAVar3);
    var kill_ = Fusion_Generator.kill_(MonadKill3);
    return function (v) {
        return function (loadDirection) {
            return function (speedtestId) {
                return function (v1) {
                    return bind(empty)(function (av) {
                        var emit = function (v2) {
                            return put(v2)(av);
                        };
                        return bind($$new({
                            speeds: [  ],
                            bytes: mempty2,
                            tcpStatsActive: [  ],
                            tcpStatsPassive: [  ]
                        }))(function (ref) {
                            var executor = bracket(groupedAverage(v1.countStreams)(loadIntermediate(v.engineConnection)(loadDirection)({
                                urls: v1.urls,
                                countStreams: v1.countStreams
                            })))(function (bc) {
                                return function (gen) {
                                    if (bc instanceof Control_Monad_Fork_Class.Completed) {
                                        return pure1(Data_Unit.unit);
                                    };
                                    if (bc instanceof Control_Monad_Fork_Class.Killed) {
                                        return Fusion_Generator.cancel(gen);
                                    };
                                    if (bc instanceof Control_Monad_Fork_Class.Failed) {
                                        return discard1(emit(new Data_Either.Left(bc.value0)))(function () {
                                            return Fusion_Generator.cancel(gen);
                                        });
                                    };
                                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 96, column 13 - line 102, column 31): " + [ bc.constructor.name ]);
                                };
                            })(function (gen) {
                                return forever(bind(Fusion_Generator.next(gen))(function (v2) {
                                    if (v2 instanceof Data_Either.Left) {
                                        return throwError1(v2.value0);
                                    };
                                    if (v2 instanceof Data_Either.Right) {
                                        return discard1(emit(new Data_Either.Right(v2.value0)))(function () {
                                            if (v2.value0 instanceof Fusion_LoadIntermediate.Current) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        speeds: state.speeds,
                                                        tcpStatsActive: state.tcpStatsActive,
                                                        tcpStatsPassive: state.tcpStatsPassive,
                                                        bytes: v2.value0.value0.bytes
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadIntermediate.TotalIntermediate) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        bytes: state.bytes,
                                                        tcpStatsActive: state.tcpStatsActive,
                                                        tcpStatsPassive: state.tcpStatsPassive,
                                                        speeds: Data_Array.snoc(state.speeds)(v2.value0.value0.speed)
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadIntermediate.StreamIntermediate) {
                                                return pure1(Data_Unit.unit);
                                            };
                                            if (v2.value0 instanceof Fusion_LoadIntermediate.IntermediateStatsPassive) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        speeds: state.speeds,
                                                        bytes: state.bytes,
                                                        tcpStatsActive: state.tcpStatsActive,
                                                        tcpStatsPassive: append([ v2.value0.value0 ])(state.tcpStatsPassive)
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadIntermediate.IntermediateStatsActive) {
                                                return modify_(ref)(function (state) {
                                                    return {
                                                        speeds: state.speeds,
                                                        bytes: state.bytes,
                                                        tcpStatsPassive: state.tcpStatsPassive,
                                                        tcpStatsActive: append([ v2.value0.value0 ])(state.tcpStatsActive)
                                                    };
                                                });
                                            };
                                            if (v2.value0 instanceof Fusion_LoadIntermediate.Warning) {
                                                return pure1(Data_Unit.unit);
                                            };
                                            if (v2.value0 instanceof Fusion_LoadIntermediate.Final) {
                                                return pure1(Data_Unit.unit);
                                            };
                                            throw new Error("Failed pattern match at Fusion.LoadFinal (line 111, column 15 - line 135, column 37): " + [ v2.value0.constructor.name ]);
                                        });
                                    };
                                    throw new Error("Failed pattern match at Fusion.LoadFinal (line 106, column 11 - line 135, column 37): " + [ v2.constructor.name ]);
                                }));
                            });
                            return bind(fork(Data_Function.flip(catchError)(function (err) {
                                return emit(new Data_Either.Left(err));
                            })(bind(now)(function (timeStart) {
                                return bind(parOneOf([ voidLeft(delay(v1.duration))(true), voidLeft(executor)(false) ]))(function (v2) {
                                    return when(v2)(bind(now)(function (timeEnd) {
                                        return bind(read(ref))(function (state) {
                                            return discard1(when($$null(state.speeds))((function () {
                                                if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                                                    return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.DnCn52.value)("No intermediates on download"));
                                                };
                                                if (loadDirection instanceof Data_LoadDirection.UploadP) {
                                                    return throwError1(Fusion_Data_FSError.mk(Fusion_Data_FSError.UpCn52.value)("No intermediates on upload"));
                                                };
                                                throw new Error("Failed pattern match at Fusion.LoadFinal (line 156, column 13 - line 160, column 84): " + [ loadDirection.constructor.name ]);
                                            })()))(function () {
                                                var activeModel = infosToModels(state.tcpStatsActive);
                                                var finalStatsActive = calcStatsFinal(activeModel);
                                                var passiveModel = infosToModels(state.tcpStatsPassive);
                                                var finalStatsPassive = calcStatsFinal(passiveModel);
                                                var calcRequest = {
                                                    intermediateValues: state.speeds,
                                                    speedtestId: speedtestId,
                                                    transferDuration: Fusion_Data_Timestamp.diff(timeEnd)(timeStart),
                                                    transferredBytes: state.bytes,
                                                    tcpStats: {
                                                        active: activeModel,
                                                        passive: passiveModel,
                                                        activeFinal: finalStatsActive,
                                                        passiveFinal: finalStatsPassive
                                                    }
                                                };
                                                return bind(v.calcLoad(calcRequest))(function (calcResult) {
                                                    return emit(new Data_Either.Right(new Fusion_LoadIntermediate.Final({
                                                        speed: calcResult.speed,
                                                        jitter: calcResult.jitter,
                                                        statsActive: finalStatsActive,
                                                        statsPassive: finalStatsPassive
                                                    })));
                                                });
                                            });
                                        });
                                    }));
                                });
                            }))))(function (fiber) {
                                return pure1({
                                    next: take(av),
                                    cancel: kill_(fiber)
                                });
                            });
                        });
                    });
                };
            };
        };
    };
};
var calcDownload = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var liftEither = Control_Monad_Error_Class.liftEither((dictMonadApp.MonadKill3()).MonadThrow1());
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (sdk) {
        return function (request) {
            return bind(sdk.calcDownload(request))(function (calcResult) {
                return bind(liftEither(lmap(fromJsonDecodeError21(Fusion_Data_FSError.Cl65.value)(calcResult))(Fusion_Foreign_Data_NQValue.decodeFSDownloadFinal(calcResult))))(function (v) {
                    return pure1({
                        speed: v.speed,
                        jitter: v.jitter
                    });
                });
            });
        };
    };
};
var addSpeedtestIdParam = function (dictFunctor) {
    var map2 = Data_Functor.map(dictFunctor);
    return function (speedtestId) {
        return function (urls) {
            var add = MST_Data_BasicURL.addQueryParameterIfNotExists("speedtestId")(new Data_Maybe.Just(speedtestId));
            var convert = function (v) {
                return {
                    load: add(v.load),
                    stats: map1(add)(v.stats)
                };
            };
            return map2(convert)(urls);
        };
    };
};
var addDisableCorsParam = function (dictFunctor) {
    var map2 = Data_Functor.map(dictFunctor);
    return function (urls) {
        var add = MST_Data_BasicURL.addQueryParameterIfNotExists("disable_cors")(new Data_Maybe.Just("rof-kict-flam"));
        var convert = function (v) {
            return {
                load: add(v.load),
                stats: map1(add)(v.stats)
            };
        };
        var $213 = eq1(Fusion_EnvVars_Common.envVarsCommon.NODE_ENV)(Fusion_EnvVars_Common.Development.value);
        if ($213) {
            return map2(convert)(urls);
        };
        return urls;
    };
};
export {
    addDisableCorsParam,
    addSpeedtestIdParam,
    calcDownload,
    calcUpload,
    downloadMock,
    loadFinal,
    stripStatsUrls,
    uploadMock
};
